import type { PaidPlan } from "@/lib/billing/planConfig";

/** One colour per tier, used everywhere a plan is named (cards, badges, art). */
export const PLAN_ACCENT: Record<"free" | PaidPlan, string> = {
  free: "#8f98a0",
  pro: "#66c0f4",
  studio: "#a78bfa",
};

export const BTN_PRIMARY =
  "inline-flex items-center justify-center gap-2 rounded-lg bg-[#66c0f4] px-4 py-2 text-sm font-semibold text-[#0d151e] transition-colors hover:brightness-110 disabled:cursor-not-allowed disabled:opacity-60";

export const BTN_SECONDARY =
  "inline-flex items-center justify-center gap-2 rounded-lg border border-[#2a475e] bg-[#16202d] px-4 py-2 text-sm font-medium text-[#c7d5e0] transition-colors hover:border-[#3a556e] hover:bg-[#1f2e3f] hover:text-white disabled:cursor-not-allowed disabled:opacity-60";

export const BTN_DANGER =
  "inline-flex items-center justify-center gap-2 rounded-lg border border-red-400/40 bg-red-500/10 px-4 py-2 text-sm font-semibold text-red-200 transition-colors hover:bg-red-500/20 disabled:cursor-not-allowed disabled:opacity-60";
